import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Success from '../../Modal/Success/Success';

import {
  TXTWCL_AwesomeX,
  TXTWCL_Your_tournament_is_createdX_Ch_ELL
} from './CreateTournamentSuccess.messages.json';
import styles from './CreateTournamentSuccess.scss';

const CreateTournamentSuccess = () => (
  <Success
    title={<Translation {...TXTWCL_AwesomeX} />}
    text={<Translation {...TXTWCL_Your_tournament_is_createdX_Ch_ELL} />}
    imageClassName={styles.image}
  />
);

export default CreateTournamentSuccess;
